import React, { ReactNode } from 'react'
import { LayoutPageWrapper } from 'goustouicomponents/dist'
import css from './TwoColumns.module.css'

interface TwoColumnsProps {
  children: ReactNode;
}

const TwoColumns = ({ children }: TwoColumnsProps) => {
  if (React.Children.count(children) < 2) {
    return null
  }

  return (
    <LayoutPageWrapper>
      <section className={css.wrapper}>
        {children && children[0 as keyof ReactNode]}
        {/* eslint-disable-next-line react/self-closing-comp */}
        <div className={css.spacing}></div>
        {children && children[1 as keyof ReactNode]}
      </section>
    </LayoutPageWrapper>
  )
}

export { TwoColumns }
